import { ProductGroupEntity } from '@/domains/business-unit/entities';
import { FindProductGroupUseCase } from '@/domains/business-unit/usecases';
import { useCallback, useState } from 'react';
import { BusinessUnitHttpRepository } from '../adapters/repositories/business-unit.http.repository';

let cachedProductGroups: ProductGroupEntity[] | null = null;
let productGroupsInflight: Promise<ProductGroupEntity[]> | null = null;

async function fetchProductGroups(): Promise<ProductGroupEntity[]> {
  if (cachedProductGroups) {
    return cachedProductGroups;
  }
  if (!productGroupsInflight) {
    productGroupsInflight = (async () => {
      try {
        const findProductGroupUsecase = new FindProductGroupUseCase(new BusinessUnitHttpRepository());
        cachedProductGroups = (await findProductGroupUsecase.run()) ?? [];
      } catch {
        cachedProductGroups = [];
      }
      return cachedProductGroups;
    })().finally(() => {
      productGroupsInflight = null;
    });
  }
  return productGroupsInflight;
}

export default function GetProductGroupListViewModel() {
  const [productGroups, setProductGroups] = useState<ProductGroupEntity[]>(cachedProductGroups ?? []);

  const actionGetProductGroups = useCallback(async () => {
    const result = await fetchProductGroups();
    setProductGroups(result);
  }, []);

  return {
    productGroups,
    actionGetProductGroups,
  };
}
